/**
 * Trasforma un secure_url Cloudinary nell'URL della variante "da visualizzazione":
 * larghezza limitata, qualità e formato automatici (webp/avif dove supportati).
 *
 * Perché: `secure_url` punta all'ORIGINALE caricato dall'admin (anche 5-15MB per
 * foto da smartphone) — usarlo direttamente in un <img> significa scaricare tutto
 * l'originale a ogni visualizzazione (era la causa dei ~10s di attesa in galleria).
 * Cloudinary genera on-the-fly la variante inserendo la trasformazione nell'URL,
 * lo stesso meccanismo del `resizedUrl` (w_500) creato dal server per le card.
 *
 * `c_limit` non ingrandisce mai le immagini più piccole del limite.
 */
export const getCloudinaryDisplayUrl = (url, transform = 'w_1600,c_limit,q_auto,f_auto') => {
    if (!url || typeof url !== 'string' || !url.includes('/upload/')) return url;
    return url.replace('/upload/', `/upload/${transform}/`);
};
